// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';

const SwiperGalleries = function () {

    //galeria webdoor
    const gallerySwiperWebdoor = () => {

        const slideCount = document.querySelectorAll('.webdoorSwiper .swiper-slide').length;
        // init Swiper:
        const swiper = new Swiper('.webdoorSwiper', {
            speed       : 2000,
            loop: slideCount >= 3,
            slidesPerView: "auto",
            effect      : 'slide',
            centeredSlides: true,
            observer: true,
            observeParents: true,
            autoplay    : {
                delay: 50000,
                disableOnInteraction: false,
              },
            pagination  : {
                el: ".swiper-pagination",
                clickable: true,
                renderBullet: function (index, className) {
                  return '<span class="' + className + '">' + (index + 1) + "</span>";
                },
              },
        });
    }

    //galeria basica (onde quiser)
    const galleryBasicSwiper = () => {

        const galBasic = document.querySelectorAll('.gallery-basic');

        for( let i=0; i< galBasic.length; i++ ) {

            galBasic[i].classList.add('swiper-container-gallery-basic-' + i);

            const swiperHL = new Swiper('.swiper-container-gallery-basic-' + i, {
                speed           : 2000,
                loop            : true,
                effect          : 'coverflow',
                //autoplay        : false,
                autoplay        : {
                    delay: 5000,
                    disableOnInteraction: false,
                },
            });

        }

    }

    // galeria simples com setas
        //galeria basica (onde quiser)
        const gallerySimpleSwiper = () => {

            const galSimple  = document.querySelectorAll('.gallery-simple');

            for( let i=0; i< galSimple.length; i++ ) {

                const _parent = galSimple[i].closest('.row-gallery');
                galSimple[i].classList.add('swiper-container-gallery-simple-' + i);
                _parent.querySelector('.swiper-button-prev').classList.add(('swiper-button-prev-simple-' + i));
                _parent.querySelector('.swiper-button-next').classList.add(('swiper-button-next-simple-' + i));
                _parent.querySelector('.swiper-pagination').classList.add(('swiper-pagination-' + i));

                const swiperHL = new Swiper('.swiper-container-gallery-simple-' + i, {
                    speed           : 2000,
                    loop            : true,
                    effect          : galSimple[i].classList.contains('effect-slide') ? 'slide' : 'coverflow',
                    // autoplay        : false,
                    autoplay        : {
                        delay: 3500,
                        // disableOnInteraction: false,
                    },
                    navigation: {
                        nextEl: '.swiper-button-next-simple-' + i,
                        prevEl: '.swiper-button-prev-simple-' + i,
                    },
                    pagination  : {
                        el: ".swiper-pagination-" + i,
                        clickable: true,
                        renderBullet: function (index, className) {
                        return '<span class="' + className + '">' + (index + 1) + "</span>";
                        },
                    },
                });

            }

        }


    //galeria highlights
    const galleryHightlightsSwiper = () => {

        const galHighLights = document.querySelectorAll('.hightlightsSwiper');

        for( let i=0; i< galHighLights.length; i++ ) {

            galHighLights[i].classList.add('swiper-container-hightLight-' + i);

            const swiperHL = new Swiper('.swiper-container-hightLight-' + i, {
                slidesPerView   : 1,
                speed           : 2000,
                loop            : true,
                spaceBetween    : 14,
                effect          : 'slide',
                //autoplay        : false,
                autoplay        : {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                    },
                    1200: {
                      slidesPerView: 3,
                    },
                }
            });

            $(galHighLights[i]).closest('.wrap-swiper').find(".swiper-nav-left").on('click', function(e){
                e.preventDefault()
                swiperHL.slidePrev(1000);
            })
            $(galHighLights[i]).closest('.wrap-swiper').find(".swiper-nav-right").on('click', function(e){
                e.preventDefault()
                swiperHL.slideNext(1000);
            })

        }

    }

    //galeria designers
    const galleryDesignersSwiper = () => {

        const galDesigner = document.querySelectorAll('.galleryDesignersSwiper');

        for( let i=0; i< galDesigner.length; i++ ) {

            galDesigner[i].classList.add('swiper-container-designers-' + i);

            const swiperDesigners = new Swiper('.swiper-container-designers-' + i, {
                slidesPerView   : 1,
                speed           : 2000,
                loop            : true,
                spaceBetween    : 14,
                effect          : 'slide',
                //autoplay        : false,
                autoplay        : {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                    },
                    1200: {
                      slidesPerView: 3,
                    },
                }
            });

            $(galDesigner[i]).closest('.wrap-swiper').find(".swiper-nav-left").on('click', function(e){
                e.preventDefault()
                swiperDesigners.slidePrev(1000);
            })
            $(galDesigner[i]).closest('.wrap-swiper').find(".swiper-nav-right").on('click', function(e){
                e.preventDefault()
                swiperDesigners.slideNext(1000);
            })

        }

    }

    return {

        init : () => {
            gallerySwiperWebdoor();
            galleryBasicSwiper();
            gallerySimpleSwiper();
            galleryHightlightsSwiper();
            galleryDesignersSwiper();
        }

    }

}();

export default SwiperGalleries;
